import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';
import { setLoaded, setLoading, withCallState } from '@twist/core';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationManagementService } from '../services/organization-management.service';
import { Organization, UpdateOrganizationCommand } from '@twist/backbone-api-services/ciam';
import { CONTEXT_ORGANIZATION_KEY } from '../../index';

export interface OrganizationStoreState {
  organizationKey: string | undefined;
  organization: Organization | undefined;
}

const initialState: OrganizationStoreState = {
  organizationKey: undefined,
  organization: undefined
};

export const OrganizationStore = signalStore(
  withState<OrganizationStoreState>(initialState),
  withCallState(),
  withComputed(state => {
      return {};
    }
  ),
  withMethods(state => {

    const _router = inject(Router);
    const _organizationsService = inject(OrganizationManagementService);

    const organizationKey = inject(CONTEXT_ORGANIZATION_KEY);

    const initialize = async () => {
      console.log('[OrganizationStore] - Initializing');
      patchState(state, setLoading());

      if (!organizationKey) {
        await _router.navigateByUrl('/errors/404', { skipLocationChange: true });
        return;
      }

      _organizationsService.getOrganization(organizationKey)
        .then(result => {
          patchState(state, {
            organizationKey,
            organization: result.organization,
            ...setLoaded()
          });
        });
    };

    const updateOrganization = async (organizationKey: string, updateData: UpdateOrganizationCommand) => {
      console.log('[OrganizationStore] - Updating Organization');
      patchState(state, setLoading());

      try {
        const updatedOrganization = await _organizationsService.updateOrganization(organizationKey, updateData);
        patchState(state, {
          organization: updatedOrganization,
          ...setLoaded()
        });
        console.log('[OrganizationStore] - Organization updated successfully');
      } catch (error) {
        console.error('[OrganizationStore] - Failed to update organization', error);
        patchState(state, { ...setLoaded() });
      }
    };

    const deleteOrganization = async (organizationKey: string) => {
      console.log('[OrganizationStore] - Deleting Organization');
      patchState(state, setLoading());

      try {
        await _organizationsService.deleteOrganization(organizationKey);
        patchState(state, {
          organizationKey: undefined,
          organization: undefined,
          ...setLoaded()
        });
        console.log('[OrganizationStore] - Organization deleted successfully');
        await _router.navigateByUrl('/organizations'); // Navigate to a meaningful page after deletion
      } catch (error) {
        console.error('[OrganizationStore] - Failed to delete organization', error);
        patchState(state, { ...setLoaded() });
      }
    };

    return { initialize, updateOrganization, deleteOrganization };
  }),
  withHooks({
    onInit: store => {
      store.initialize();
    }
  })
);
